<template>
    <div :class="classNames">
        <div :class="commonName+ '_search'">
            <div :class="commonName+ '_search_con_item'">
				<el-button type="primary" @click="addCommentFun">添加评论</el-button>
			</div>
            <div :class="commonName+ '_search_con'">
				<div :class="commonName+ '_search_con_item'">
					<span :class="commonName+ '_search_con_item_title'">提交时间</span>
					<el-date-picker v-model="times" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" @change="changeTime" value-format="yyyy-MM-dd">
					</el-date-picker>
				</div>
                <div :class="commonName+ '_search_con_item'">
                    <span :class="commonName+ '_search_con_item_title'">课程标题</span>
                    <el-input placeholder="请输入课程标题" v-model="searchObj.title"></el-input>
                </div>
                <div :class="commonName+ '_search_con_item'">
                    <span :class="commonName+ '_search_con_item_title'">状态</span>
                    <el-select v-model="searchObj.status" @change="changeStatus">
                        <el-option label="全部" value="" :key="-1"></el-option>
                        <el-option v-for="(item, index) in stateList" :label="item.label" :value="item.value" :key="index"></el-option>
                    </el-select>
                </div>
                <div :class="commonName+ '_search_con_item'">
                    <span :class="commonName+ '_search_con_item_title'">小程序</span>
                    <el-select v-model="searchObj.come_from" @change="changeStatus">
                        <el-option v-for="(item, index) in comeForm" :label="item.label" :value="item.value" :key="index"></el-option>
                    </el-select>
                </div>
				<div :class="[commonName+ '_search_con_item', commonName+ '_oprtation']">
					<el-button type="primary" @click="searchRes">查询</el-button>
				</div>
			</div>
        </div>
        <div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table :data="tableList.data"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
                    <el-table-column v-for="(item, index) in headerList" :key="index" :prop="item.prop" :label="item.label" :width="item.width" :align="item.align" :show-overflow-tooltip="item.tooltip">
						<template slot-scope="scope">
                            <div v-if="item.prop === 'user'" :class="classNames+ '_user'">
                                <img :src="scope.row.user_avatar_url || require('@/assets/image/comment.png')" alt="">
                                <span>{{scope.row.nickname}}</span>
                            </div>
                            <div v-else-if="item.prop === 'score'">
                                <i class="el-icon-star-on" v-for="(item, index) in parseInt(scope.row[item.prop])" :key="index" style="color: rgb(247,186,42)"></i>
                            </div>
                            <div v-if="item.prop === 'come_from'">
                                <span>{{comeFormList[scope.row[item.prop]]}}小程序</span>
                            </div>
                            <span v-else>{{scope.row[item.prop]}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="60" fixed="right">
						<template slot-scope="scope">
                            <div :class="commonName+'_operation_title'" v-if="handleShow(scope.row.ty, 1)" @click="handleOpea(scope.row.id, 1)">通过</div>
                            <div :class="commonName+'_operation_title'" v-if="handleShow(scope.row.ty, 2)" @click="handleOpea(scope.row.id, 2)">拒绝</div>
                            <div :class="commonName+'_operation_title'" @click="handleOpea(scope.row.id, 3)">删除</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<Pagination @change="changeSize" :total="tableList.count" ref="pagination" v-model="searchObj.page" v-if="Math.ceil(tableList.count / searchObj.limit) > 1"></Pagination>
		</div>
        <el-dialog
            title="添加评论"
            :visible.sync="dialogVisible"
            width="600px"
            @close="handleClose"
            >
            <el-form ref="ruleForm" :rules="rules" :model="commentForm" label-position="left" label-width="100px">
                <el-form-item label="课程" prop="product_id">
                    <el-select v-model="commentForm.product_id" :popper-class="classNames+ '_select'" :ref="classNames+ '_select'">
                        <el-option v-for="(item, index) in courseGetcourseList.data" :label="item.title" :value="item.id" :key="index">
                            <p>{{item.title}}</p>
                        </el-option>
                        <el-option label="" :value="-1" :disabled="true">
                            <p style="height: 30px;text-align:center" v-if="titleObj.page < Math.ceil(courseGetcourseList.count / titleObj.limit)"><span style="margin-right: 6px">加载中</span><i class="el-icon-loading"></i></p>
                            <template v-else>
                                <p style="height: 30px;text-align:center" v-if="!loading"><span style="margin-right: 6px">已经到底啦～～</span></p>
                            </template>
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="评论日期" prop="created_time">
					<el-date-picker  label="评论日期" prop="created_time"
					  placeholder="选择日期时间"
					  type="datetime"
					  value-format="yyyy-MM-dd HH:mm:ss"
					   :picker-options="pickerOptions1"
					  v-model="commentForm.created_time"
					  @change="handleNew"
					  >
					  </el-date-picker>
			  </el-form-item>
			 
                <el-form-item label="评论内容" prop="comment">
                    <el-input placeholder="请输入评论内容" v-model="commentForm.comment" type="textarea"  :autosize="{minRows: 4, maxRows: 6}"></el-input>
                </el-form-item>
                <el-form-item label="星级" prop="score">
                    <div style="display: flex;align-items: center;height:40px">
                        <el-rate v-model="commentForm.score"></el-rate>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { commentData } from './data.js'
export default {
    name: 'Comment',
    mixins: [commentData],
    data() {
        const testScore = (value, callback, title) => {
            if(!value) {
                callback(new Error(title))
            }
            callback()
        }
        return {
            classNames: 'comment',
            noDataName: 'empty',
            dialogVisible: false,
            tableList: {
                data: [],
                count: 0
            },
            searchObj: {
                limit: 10,
                page: 1,
                title: '',
                create_start_time: '',
                create_end_time: '',
                status: '',
                come_from:""
            },
            times: [],
            commentForm: {
                product_id: '',
                comment: '',
				created_time:'',
                score: 0
            },
            rules: {
                product_id: [
                    { 
                        required: true,
                        message: '请选择课程', 
                        trigger: 'change'
                    }
                ],
                comment: [
                    { 
                        required: true,
                        message: '请输入评论内容', 
                        trigger: 'change'
                    },
                   { max: 200, message: '长度最多200个字', trigger: 'blur' }
                ],
				
                score: [
                    { 
                        required: true,
                        trigger: 'change',
                        validator: (rule, value, callback) => {
                            testScore(value, callback, '请选择评分')
                        } 
                    }
                ],
				created_time: [
                    { 
                        required: true,
                        trigger: 'change',
                        validator: (rule, value, callback) => {
                            testScore(value, callback, '请选择日期')
                        } 
                    }
                ]
            },
            stateList: [
                {	label: '待审核',
                    value: 3,
                },
                {
                    label: '审核通过',
                    value: 1,
                },
                {
                    label: '已驳回',
                    value: 2,
                }
            ],
            courseGetcourseList: {
                count: 0,
                data: []
            },
            titleObj: {
                page: 1,
                limit: 10,
                unlestatus: -1
            },
            loading: false,
			comeForm:[
                {	label: '全部',
                    value:"",
                },
                {
                    label: '抖音',
                    value: 1,
                },
                {
                    label: '快手',
                    value: 2,
                },
                {
                    label: '微信',
                    value: 3,
                }
            ],
            comeFormList:{
                1:'抖音',
                2:'快手',
                3:'微信'
            }
        }
    },
    created() {
        this.getUserComment()
        this.getCourseGetcourse()
    },
    computed: {
        ...mapState(['breadCrumbList']),
		pickerOptions1() {
		       var _this=this;
		       return {
		         disabledDate(time) {
		           var time1 = 1622476800000;// 起始时间
		           return time.getTime() > Date.now() || time.getTime() < time1;
		         }
		       }
		     }
    },
    methods: {
        ...mapActions('class', ['userComment', 'courseGetcourse', 'addComment', 'auditComment', 'delComment']),
		handleNew(data) {
		       var startAt = new Date(data) * 1000 /1000;
			   console.log(123,data,startAt , Date.now(),startAt > Date.now());
		        if(startAt > Date.now()) {
		            this.commentForm.created_time = this.formatDateTime(new Date())
		        }
		    },
		formatDateTime (date) {
		  var y = date.getFullYear();
		  var m = date.getMonth() + 1;//注意这个“+1”
		  m = m < 10 ? ('0' + m) : m;
		  var d = date.getDate();
		  d = d < 10 ? ('0' + d) : d;
		  var h = date.getHours();
		  h=h < 10 ? ('0' + h) : h;
		  var minute = date.getMinutes();
		  minute = minute < 10 ? ('0' + minute) : minute;
		  var second=date.getSeconds();
		  second=second < 10 ? ('0' + second) : second;
		  return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
		},
        submit() {
            this.$refs.ruleForm.validate(async (volid) => {
                if(volid) {
                    console.log(this.commentForm, '...this.commentForm')
                    await this.addComment(this.commentForm)
                    this.dialogVisible = false
                    this.changeSize(1)
                    this.$message({
                        type: 'success',
                        message: '添加成功',
                        duration: 3000
                    })
                }
            })
        },
        async handleOpea(id, status) {
            let objStatus = {
                1: '审核',
                2: '驳回',
                3: '删除'
            }
            let checkStatus = () => {
                return new Promise((resolve) => {
                    this.$confirm(`你确定${objStatus[status]}该条评论吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        resolve(true)
                    }).catch(() => {  
                        resolve(false)    
                    })
                })
            }
            let flag = status === 2 || status === 3? await checkStatus() : true
            if(!flag) {
                return
            }
            status === 3? await this.delComment({id}) :await this.auditComment({
                comment_id: id,
                ty: status
            })
            this.getUserComment()
            this.$message({
                type: 'success',
                message: objStatus[status] +  '成功',
                duration: 3000
            })
        },
        handleClose() {
            this.commentForm =  {
                product_id: '',
                comment: '',
				created_time:'',
                score: 0
            }
            this.$nextTick(() => {
                // let dom = document.querySelector(`.${this.classNames + '_select'} .el-scrollbar__wrap`)
                // dom.scrollTop = 0
                this.$refs.ruleForm.clearValidate()
            })
        },
        addCommentFun() {
            this.dialogVisible = true
            this.$nextTick(() => {
                let dom = document.querySelector(`.${this.classNames + '_select'} .el-scrollbar__wrap`)
                dom.addEventListener('scroll', (e)=> {
                    let clientHeight = dom.clientHeight
                    let scrollHeight = dom.scrollHeight
                    if(clientHeight + e.target.scrollTop + 10 >= scrollHeight && !this.loading && this.titleObj.page < Math.ceil(this.courseGetcourseList.count / this.titleObj.limit)) {
                        this.loading = true
                        this.titleObj.page++
                        this.getCourseGetcourse(true)
                    }
                }, false)
            })
        },
        async getUserComment() {
            let res = await this.userComment(this.searchObj)
            this.tableList = res
            console.log(res, 'pppp')
        },
        async getCourseGetcourse(flag) {
            console.log(flag)
            let res = await this.courseGetcourse(this.titleObj)
            this.loading = false
            if(flag) {
                this.courseGetcourseList = {
                    data: [...this.courseGetcourseList.data, ...res.data],
                    count: res.count
                }
            } else {
                this.courseGetcourseList = res
            }
        },
        handleShow(value, type) {
			if(value === ''){
				return
			}
			let obj = {
                1: [3],
				2: [3]
			}
			if(obj[type].includes(value)) {
				return true
			} 		
		},
        changeTime() {
            this.searchObj.start_time = this.times && this.times.length ? this.times[0] : ''
			this.searchObj.end_time = this.times && this.times.length ? this.times[1] : ''
        },
        changeStatus() {
            this.changeSize(1)
        },
        changeSize(size) {
            this.searchObj.page = size
            this.getUserComment()
        },
        searchRes() {
            this.noDataName = 'noData'
            this.changeSize(1)
        }
    }
}
</script>
<style lang="less" scoped>
    @classNames: comment;
    .@{classNames} {
        height: 100%;
        .el-table::before {
			background-color: transparent;
		}
        .@{classNames}_table_bot_status_tit {
            width: 66px;
            height: 24px;
            border-radius: 12px;
            margin-right: 10px;
            text-align: center;
            line-height: 24px;
            display: block;
        }
        .@{classNames}_user {
            display: flex;
            align-items: center;
            img {
                width: 50px;
                height: 50px;
                object-fit: cover;
            }
            span {
                margin-left: 12px;
            }
        }
    }
</style>
